import * as yup from 'yup'
import { fullWidthRegExp } from '../../Utils/utils'

export function inviteMemberResolver(t) {
  return yup.object().shape({
    email: yup
      .string()
      .email(t('auth:validationMessage.emailAddressIsNotMatch'))
      .required(t('auth:validationMessage.requiredEmailAddress'))
      .matches(fullWidthRegExp, t('error_message:FULL_WIDTH_ERROR_MESSAGE'))
      .trim(),
    role: yup
      .string()
      .required(t('Role is Required'))
      .trim()
  })
}
